/**
 * Purchase Order Redux helpers (HPRMS Phase C).
 * Boot = page-1 withoutDetails; Sync = full paged; write = upsert only (no verify GET).
 */

import {
  getPurchaseOrders,
  getAllPurchaseOrdersPaged,
  PURCHASE_ORDERS_PAGE_SIZE,
} from "../apis/purchase-orders/purchaseOrders.api";

const getStore = () => require("../index").default;

export const applyPurchaseOrdersToStore = (list, dispatch = null) => {
  const d = dispatch || getStore().dispatch;
  d({
    type: "GET_PURCHASE_ORDERS",
    purchaseorders: Array.isArray(list) ? list : [],
  });
};

/**
 * Boot / light refresh — same endpoint + normalize as Sync, page 1 only.
 */
export const refreshPurchaseOrdersInStore = async ({
  start = 0,
  size = PURCHASE_ORDERS_PAGE_SIZE,
  context = "Loading Purchase Orders",
  silent = true,
  dispatch = null,
} = {}) => {
  const list = await getPurchaseOrders({
    start,
    size,
    context,
    silent,
    hideLoader: silent,
  });
  applyPurchaseOrdersToStore(list, dispatch);
  return list;
};

/**
 * Explicit Sync — full pager (same as ViewPurchaseOrder Sync button).
 */
export const refreshAllPurchaseOrdersInStore = async ({
  size = PURCHASE_ORDERS_PAGE_SIZE,
  context = "Syncing Purchase Orders",
  silent = false,
  dispatch = null,
} = {}) => {
  const list = await getAllPurchaseOrdersPaged({
    size,
    context,
    silent,
  });
  applyPurchaseOrdersToStore(list, dispatch);
  return list;
};
